import ApiBase from '../ApiBase';

class Booking extends ApiBase {
    route = '/exhibitors/bookings';
}

export default new Booking();
